<!-- 摄像头弹窗DEMO -->
<template>
  <ElDialog width="620" destroy-on-close title="视频监控" v-model="visible">
    <el-tabs v-model="activeTab" class="demo-tabs">
      <el-tab-pane label="实时视频" name="live">
        <video ref="videoRef" style="width: 100%" controls autoplay></video>
        <h4>设备信息</h4>
        <el-descriptions direction="vertical" :column="3" border>
          <el-descriptions-item label="ID">
            {{ data?.id }}
          </el-descriptions-item>
          <el-descriptions-item label="名称">
            {{ data?.name }}
          </el-descriptions-item>
          <el-descriptions-item label="描述">
            {{ data?.description }}
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
    </el-tabs>
  </ElDialog>
</template>
<script setup lang="ts">
import { CesiumObj } from '@/components/GIS/CesiumObj'
import { onMounted, ref, watch } from 'vue'
import type { Camera } from '@/apiFzu/ApiFzu'
import hlsjs from 'hls.js'
const visible = ref(false)
const data = ref<Omit<Camera, 'geom'>>()
const activeTab = ref('live')
const videoRef = ref<HTMLVideoElement>()
onMounted(async () => {
  const cesiumobj = await CesiumObj.getInstance()
  cesiumobj.layerManager.cameraLayer.on('click', (p) => {
    data.value = p
    visible.value = true
  })
})

watch(
  () => visible.value,
  (val) => {
    if (val) {
      setTimeout(() => {
        const url = data.value?.name.includes('仓山仓前中路')
          ? 'https://fzn.wisionic.com/video_yts/output.m3u8'
          : 'https://fzn.wisionic.com/video/output.m3u8'
        if (hlsjs.isSupported() && videoRef.value) {
          const hls = new hlsjs()
          hls.loadSource(url)
          hls.attachMedia(videoRef.value)
        } else if (videoRef.value && videoRef.value.canPlayType('application/vnd.apple.mpegurl')) {
          videoRef.value.src = url
        }
      })
    }
  },
  {
    immediate: true,
  }
)
</script>

<style lang="scss" scoped>
h4 {
  margin: 16px 0 12px;
  font-size: 14px;
  padding-left: 10px;
  position: relative;
  font-weight: bold;
  color: #000;
  &::before {
    content: '';
    width: 4px;
    height: 80%;
    background-color: #3b82f6;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 12px;
  }
}
</style>
